import Vue from 'vue';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import { messages } from 'vee-validate/dist/locale/en.json';
import isURL from 'validator/lib/isURL';
import isBefore from 'validator/lib/isBefore';
import { toCurrencyWithoutSign } from '@/mixins/filter';
import { idr } from '@/mixins/filter';

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

// -----------------------
// default validation rules
// -----------------------

for (let [rule, validation] of Object.entries(rules)) {
  extend(rule, {
    ...validation,
    message: messages[rule]
  });
}

// -----------------------
// custom validation rules
// -----------------------

extend('url', {
  message: 'Invalid URL format',
  validate(value) {
    return isURL(value, {
      require_tld: true,
      require_protocol: true
    });
  }
});

extend('date_before', {
  message: '{_field_} cannot be greater than {target}',
  validate(value, { target }) {
    if (!target) return true;

    if (value === target) return true;

    return isBefore(value, target);
  },
  params: [
    {
      name: 'target',
      isTarget: true
    }
  ]
});

extend('cost_per_pax', {
  validate(value, { activity }) {
    if (!activity) {
      return `Type of Activity must be filled`;
    }
    const min_value = activity.min_value;
    const max_value = activity.max_value;
    if (value < min_value) {
      return `Cost per Pax must be ${toCurrencyWithoutSign(min_value)} or more`;
    }
    if (value > max_value) {
      return `Cost per Pax must be ${toCurrencyWithoutSign(max_value)} or less`;
    }

    return true;
  },
  params: [
    {
      name: 'activity'
    }
  ]
});

extend('total_budget', {
  validate(value, { target }) {
    let maxBudget = null;
    let isInsufficient = null;
    if (target) {
      maxBudget = target.poAmount - target.submitted;
      isInsufficient = target.submitted > target.poAmount;
    }
    if (!target) return true;

    if (value <= maxBudget) return true;

    if (isInsufficient) {
      return `Insufficient Budget`;
    } else {
      return `{_field_} can not more than ${idr(maxBudget)}`;
    }
  },
  params: [
    {
      name: 'target'
    }
  ]
});

extend('total_amount_event', {
  validate(value, { target }) {
    if (!target) return true;

    if (value === target) return true;

    return `{_field_} must be equal as ${toCurrencyWithoutSign(target)}`;
  },
  params: [
    {
      name: 'target'
    }
  ]
});
extend('total_amount', {
  validate(value, { target }) {
    if (!target) return true;

    if (value === target) return true;

    if (+value === +target) {
      return true;
    }

    return `{_field_} must be equal as ${toCurrencyWithoutSign(target)}`;
  },
  params: [
    {
      name: 'target'
    }
  ]
});

extend('payment_stage', {
  validate(value, { amountOfSupport }) {
    const totalAmount = value.reduce((prev, item) => {
      return prev + item.amount;
    }, 0);
    const totalPercentage = value.reduce((prev, item) => {
      return prev + +item.percentage;
    }, 0);

    if (!amountOfSupport) {
      return `Amount of support must be filled`;
    }

    if (totalPercentage !== 100) {
      return `Total percentage must be equal as 100`;
    }

    const isSame = totalAmount === amountOfSupport;
    if (!isSame) {
      return `Total amount must be equal as ${toCurrencyWithoutSign(
        amountOfSupport
      )}`;
    }

    return true;
  },
  params: [
    {
      name: 'amountOfSupport'
    }
  ]
});
